import site from './profile/fr/site';
import footer from './profile/fr/footer';
import home from './profile/fr/home';
import about from './profile/fr/about';
import projectsPage from './profile/fr/projectsPage';
import projects from './profile/fr/projects';
import expertise from './profile/fr/expertise';
import contact from './profile/fr/contact';

const profileContentFr = {
  site,
  footer,
  home,
  about,
  projectsPage,
  projects,
  expertise,
  contact,
};

export default profileContentFr;
